import React from "react";
import UsersCommon from "../UsersMain";

const TrialExpired = () => {
  const type = "Trial Expired";
  const title = "Trial Expired";
  return <UsersCommon type={type} title={title} />;
};

export default TrialExpired;
